import Vehicles from "containers/Vehicles";
import useBoundStore from "store";

interface TimelineEventVehiclesVotesProps {
  onBack?: () => void;
}

export default function TimelineEventVehiclesVotes(props: TimelineEventVehiclesVotesProps): JSX.Element | null {
  const { onBack } = props;
  const selected = useBoundStore((state) => state.selected);

  return (
    <Vehicles
      onBack={onBack}
      users={selected.timelineEvent?.users ?? []}
      viewMode
      votes={selected.timelineEvent?.votes ?? []}
    />
  );
}
